"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLabelPoint = exports.IkeDrawBindings = void 0;
var drawable_accept_binding_1 = require("./drawable.accept.binding");
var drawable_delete_binding_1 = require("./drawable.delete.binding");
var image_zoom_binding_1 = require("./image.zoom.binding");
var line_create_binding_1 = require("./line.create.binding");
var marker_create_binding_1 = require("./marker.create.binding");
Object.defineProperty(exports, "getLabelPoint", { enumerable: true, get: function () { return marker_create_binding_1.getLabelPoint; } });
var selection_move_binding_1 = require("./selection.move.binding");
exports.IkeDrawBindings = {
    Selection: {
        move: selection_move_binding_1.selectionMoveBinding
    },
    Image: {
        zoom: image_zoom_binding_1.imageZoomBinding
    },
    Measurement: {
        delete: drawable_delete_binding_1.drawableDeleteBinding,
        accept: drawable_accept_binding_1.drawableAcceptBinding,
        Marker: {
            create: marker_create_binding_1.drawableMarkerCreateBinding,
            link: marker_create_binding_1.drawableMarkerCreateBinding
        },
        Line: {
            create: line_create_binding_1.drawableLineCreateBinding
        }
    }
};
//# sourceMappingURL=index.js.map